import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsLocaleService } from 'ngx-foundation';
import { ProfileService } from '../_services/profiles.service';
import { Profile } from '../_models/profile.model';
import { Subscription } from 'rxjs/Subscription';
import { SearchParameters } from '../_viewmodels/search-params.viewmodel';
import { SearchService } from '../_services/search.service';
import { CertificadoMasivo } from '../_models/certificado-masivo.model';
import { User } from '../_models/user.model';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from '../_services/environment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { ModalService } from '../_services/modal.service';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { stringify } from 'querystring';
import { getDate } from 'ngx-foundation/chronos/utils/date-getters';
import { CertificadoMasivoDetalle } from '../_models/certificado-masivo-detalle.model';


@Component({
  selector: 'app-certificadosmasivos',
  templateUrl: './certificadosmasivos.component.html',
  styleUrls: ['./certificadosmasivos.component.scss'],
  providers: [SearchService],
})
export class CertificadosmasivosComponent implements OnInit, OnDestroy {

  error: boolean;
  loading: boolean;
  isEmpty: boolean;
  ruta:string;
  rutaPdf:string;
  searchHasBeenMade: boolean;
  modalRadicado: string;
  currentProfile: Profile;
  currentUser: User;
  public isCollapsed = false;
  profileSubscription: Subscription;
  certificados: CertificadoMasivo[];
  certificadoActual:CertificadoMasivo;
  detalleActual:CertificadoMasivoDetalle[];
  showVerButton = true;
  //urlPdf: SafeResourceUrl;
  // FontAwesome icons
  faDownload = faDownload;

  constructor(
    private profilesService: ProfileService,
    private localeService: BsLocaleService,
    private searchService: SearchService,
    private authenticationService: AuthenticationService,
    private envService: EnvironmentService,
    private _modalService: ModalService,
    private location: Location,
    private router: Router,
    public sanitizer:DomSanitizer,) {
      //this.showVerButton = this.envService.showDocumentViewer;
      this.localeService.use('es');
      //this.ruta = window.location.href.substr(0, window.location.href.indexOf('/certificados'));
      this.ruta = this.envService.urlPdf;
  }

  checkUserToken() {
    // let isTokenValid = false;
    this.authenticationService.checkUserToken()
      .subscribe((response: any) => {

      },
      error => {

      });
  }

  ngOnInit() {
    this.checkUserToken();
    this.loading = false;
    this.error = false;
    this.isEmpty = false;
    this.searchHasBeenMade = false;
    this.currentProfile = this.profilesService.getSelectedProfile();
    // Subscribe to user's profile change
    this.profileSubscription = this.profilesService.selectedProfileSubject.subscribe(
      (profile: Profile) => {
        this.currentProfile = profile;
        this.currentUser = this.authenticationService.currentUserValue;
      }
    );
    this.certificados = [];
    //this.urlPdf= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

  cleanSearchFilters(form: NgForm) {
    form.resetForm();
  }

  onSubmitSearch(form: NgForm) {
    this.loading = true;
    this.error = false;
    this.searchHasBeenMade = true;
    this.certificados = [];
    const fvalue = form.value;

    // Asignar fecha a primera hora del día escogido.
    if (fvalue.fechaTramiteDesde) {
      fvalue.fechaTramiteDesde.setHours(0, 0, 0);
    }
    // Asignar fecha a última hora del día escogido.
    if (fvalue.fechaTramiteHasta) {
      fvalue.fechaTramiteHasta.setHours(23, 59, 59);
    }

    const searchParameters: SearchParameters = new SearchParameters();
    Object.assign(searchParameters, form.value as SearchParameters);
    // Cambiar Asignación Fecha Desde
    searchParameters.fechaTramiteDesde = fvalue.fechaTramiteDesde
      ? fvalue.fechaTramiteDesde.toISOString()
      : '';
    // Cambiar Asignación Fecha Hasta
    searchParameters.fechaTramiteHasta = fvalue.fechaTramiteHasta
      ? fvalue.fechaTramiteHasta.toISOString()
      : '';
    // INICIO Datos Obligatorios Para Consulta
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentProfile && this.currentUser) {
      // Asignar Perfil Actual
      searchParameters.currentProfileName = this.currentProfile.profile_name
        ? this.currentProfile.profile_name
        : '';
      // Asignar Número de Identificación Empresa
      searchParameters.idfEmpresa = this.currentProfile.profile_company_id
        ? this.currentProfile.profile_company_id
        : '';
      if (this.currentProfile.profile_name == "Funcionario Subsidio"){
        searchParameters.idfEmpresa = fvalue.identificacion;
      }
    } else {
    }
    // FIN Datos Obligatorios Para Consulta
    // Domsanitizer

//
    this.searchService.searchCertificadosMasivos(searchParameters).subscribe(
      response => {
        this.error = false;
        this.loading = false;
        var d = new Date();
        var inicial = new Date();
        inicial.setDate(d.getDate() - 5);
        var certificadostemp = [];
        if (response.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        if (!this.isEmpty)
        {
          var index = 0;
          response.forEach(element => {
            index ++;
            var fecha = new Date(element.FechaSolicitud);
            //
            if (this.currentProfile.profile_name == 'Funcionario Subsidio'){
              this.certificados.push(element);
            }else {
              if (fecha >= inicial ){
                this.certificados.push(element);
              }
            }
          });
        }
      },
      error => {
        this.isEmpty = true;
        this.loading = false;
        this.error = true;
        const errorObject = error as HttpErrorResponse;
        if (errorObject.status === 401) {
          this.authenticationService.logout();
          this.router.navigate(['/logout']);
          // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
          // location.replace(logBackURL);
        }
      }
    );

  }

    openModalDetalle(modalId: string, tocid:string){
      // Certificado Actual
      this.certificados.forEach((cer)=>{
        if (cer.tocid == tocid){
          this.certificadoActual = cer;
        }
      });
      this._modalService.open(modalId);
      const divElem: HTMLDivElement = document.createElement('div');
          divElem.setAttribute('id', 'embeded-div');
          divElem.setAttribute('frameborder', '1');
          divElem.setAttribute('width', '80%');
          divElem.setAttribute('height', '70%');
          divElem.style.overflow="auto";
          divElem.innerHTML = "";
          //document.getElementById('iframe-goes-here').removeChild(divElem);
          if (document.getElementById('iframe-goes-here').hasChildNodes){
            document.getElementById('iframe-goes-here');
          }
          while (document.getElementById('iframe-goes-here').firstChild){
            document.getElementById('iframe-goes-here').removeChild(document.getElementById('iframe-goes-here').firstChild);
          }
          document.getElementById('iframe-goes-here').appendChild(divElem);
  
      this.searchService.searchCertificadoMasivo(tocid).subscribe(
        (response : CertificadoMasivoDetalle[])=>{
          this.detalleActual =[]; // borrar elementos
          var contenido = " <div class='tabs-panel is-active' id='results-panel'> <table><thead><tr><th></th><th>Tipo Id</th><th>No. Id</th><th>Generado</th><th>Radicado</th><th>Observaciones</th></tr></thead><tbody>";
          var count = 0;
          response.forEach((detalle)=>{
            this.detalleActual.push(detalle);
            count++;
            var radicado = detalle.Generado == 'SI'? detalle.Radicado: "";
            var observacion = detalle.Generado == 'NO'? detalle.Radicado: "";
            contenido += `<tr><td>${count}</td><td>${detalle.tipoId}</td><td>${detalle.NoId}</td><td>${detalle.Generado}</td><td>${radicado}</td><td>${observacion}</td></tr>`
          });
          contenido += "</tbody></table></div>"
          this.modalRadicado = "";
          divElem.innerHTML = contenido;
        },
        error=>{}
      );
        

        
    }
    closeModal(id: string) {
      this._modalService.close(id);
     
    }
    downloadDetail(){
 
      let csvRows = [];
      let headers = `Tipo de certificado:;${this.certificadoActual.TipoCertificado};;;Fecha de solicitud:;${this.certificadoActual.FechaSolicitud}`;
      csvRows.push(headers);
      headers = `Item;Tipo Id;No. Id;Generado;Radicado;Observaciones`;
      csvRows.push(headers);
      let nrolinea = 0;
      this.detalleActual.forEach((det)=>{
        let linea = "";
        //let nrolinea = (Number(det.pos) * 1) +1;
        nrolinea++;
        let radicado = "";
        let observaciones = "";
        if (det.Generado == "SI"){
          observaciones = "";
          radicado = det.Radicado;
        } else {
          radicado = "";
          observaciones = det.Radicado;
        }
        linea += `${nrolinea};${det.tipoId};${det.NoId};${det.Generado};${radicado};${observaciones}`;
        csvRows.push(linea);
      });

      const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]),csvRows.join('\n')], {type: 'text/csv;charset=utf-8'});
      const url = window.URL.createObjectURL(blob) 
  
      // Creating an anchor(a) tag of HTML 
      const a = document.createElement('a') 
    
      // Passing the blob downloading url  
      a.setAttribute('href', url) 
    
      // Setting the anchor tag attribute for downloading 
      // and passing the download file name 
      a.setAttribute('download', `${this.certificadoActual.IdentificacionEmpresa}_${this.certificadoActual.tocid}.csv`); 
    
      // Performing a download with click 
      a.click() 
    }
}